<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="row">
  <div class="col-12" *ngIf="!ehCadastro">


    <app-card cardTitle="Diários" blockClass="table-border-style" [options]="false">
      <div class="row">

        <button type="button" class="btn btn-primary" data-toggle="modal" (click)="inicioCadastro()">
          <i class="feather icon-plus-circle"></i>
          Cadastrar Novo Diário</button>

      </div>
      <br>
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-sm table-hover mb-0">
              <thead class="text-uppercase text-muted small">
                <tr>
                  <th class="align-middle">Título</th>
                  <th class="align-middle">Descrição</th>
                  <th class="align-middle text-center">Fase</th>
                  <th class="align-middle text-right">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of arrayDiarios" class="align-middle">
                  <td class="text-break" (click)="openModal(modalCadastroDiario, item)" style="cursor: pointer;">
                    <span class="font-weight-semibold">{{item.pergunta }}</span>
                  </td>
                  <td class="text-break" style="max-width: 380px; white-space: normal; overflow-wrap: anywhere;">
                    <span class="text-muted d-block" [innerHTML]="item.descricao"></span>
                  </td>
                  <td class="text-center">
                    <span *ngIf="item.tipo == 'P'" class="badge badge-success">Fase Prática</span>
                    <span *ngIf="item.tipo == 'M'" class="badge badge-warning">Fase Módulos</span>
                  </td>
                  <td class="text-right" style="min-width: 96px;">
                    <div class="btn-group btn-group-sm" role="group">
                      <button type="button" class="btn btn-dark" (click)="openModal(modalCadastroDiario, item)" title="Editar diário">
                        <i class="fa fa-edit"></i>
                      </button>
                      <!--
                      <button type="button" class="btn btn-danger" title="Excluir diário">
                        <i class="fa fa-trash"></i>
                      </button>
                      -->
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </app-card>
  </div>


  <div class="col-12" *ngIf="ehCadastro">
    <app-card cardTitle="Diário" blockClass="table-border-style" [options]="false">
      <app-modal-cadastro-diario (acaoVoltar)="voltar()" [item]="diarioItem">
      </app-modal-cadastro-diario>
    </app-card>
  </div>

</div>







<app-ui-modal #modalCadastroDiario [hideFooter]="true" [dialogClass]="'modal-xl'">
  <div class="app-modal-header">
    <h5 class="modal-title">Cadastro de Diário</h5>
    <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
      (click)="closeModal(modalCadastroDiario, 'modulo')"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="app-modal-body">
    <app-modal-cadastro-diario (acaoVoltar)="closeModal(modalCadastroDiario, 'diario')" [item]="diarioItem">
    </app-modal-cadastro-diario>     
  </div>
</app-ui-modal>